<template>
  <div :class="[`group-471`, className || ``]">
    <p class="text-45-1 poppins-normal-thunder-17px">{{ text1741 }}</p>
    <div class="text-449 poppins-normal-thunder-20px">{{ text1740 }}</div>
    <view482 :className="view48Props.className" />
  </div>
</template>

<script>
import View482 from "./View482";
export default {
  name: "Group47122",
  components: {
    View482,
  },
  props: ["text1741", "text1740", "className", "view48Props"],
};
</script>

<style>
.group-471 {
  display: flex;
  height: 40px;
  left: 0;
  position: absolute;
  top: 93px;
  width: 677px;
}

.text-45-1 {
  height: 26px;
  letter-spacing: 0;
  line-height: normal;
  margin-top: 2.3px;
  width: 346px;
}

.text-449 {
  height: 30px;
  letter-spacing: 0;
  line-height: normal;
  margin-left: 26px;
  margin-top: 2.3px;
  width: 135px;
}

.group-471.group-475,
.group-471.group-475-1 {
  top: 145px;
}

.group-471.group-475 .text-449,
.group-471.group-475-1 .text-449 {
  width: 141px;
}
</style>
